import { productDetail } from '@/utils/formatters/formattedDigitalDataManager';
import { changesDigitalData } from '@/utils/digitalData';

const useProductDetail = () => {
  const setDefaultProduct = ({ product, reviews }) => {
    changesDigitalData([
      'product',
      productDetail({ product, reviews }),
      'book24',
    ]);
  };

  const clearProduct = () => {
    changesDigitalData(['product', undefined, 'book24']);
  };

  return {
    setDefaultProduct,
    clearProduct,
  };
};

export default useProductDetail;
